import React from 'react';

/**
 * SVG icon library for action buttons.
 * Keeps SVGs out of component JSX for readability.
 */
export const icons = {
    fileEmail: (
        <svg viewBox="0 0 12 12">
            <rect x="1" y="1" width="10" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="1.3" />
            <path d="M3 6h6M3 8h4" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        </svg>
    ),
    createTask: (
        <svg viewBox="0 0 12 12">
            <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="1.3" />
            <path d="M6 3.5v2.5l1.5 1.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        </svg>
    ),
    draftReply: (
        <svg viewBox="0 0 12 12">
            <path d="M1 9l1.5-1.5L9 1l2 2-6.5 6.5L1 11l0-2z" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
        </svg>
    ),
    timeEntry: (
        <svg viewBox="0 0 12 12">
            <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="1.3" />
            <path d="M4 5.5h4M4 7h2.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        </svg>
    ),
    addNote: (
        <svg viewBox="0 0 12 12">
            <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="1.3" />
            <path d="M4 6h4M6 4v4" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        </svg>
    ),
    summarize: (
        <svg viewBox="0 0 12 12">
            <path d="M2 2h8v8H2z" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <path d="M4 5h4M4 7h2" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        </svg>
    ),
    check: (
        <svg viewBox="0 0 12 12">
            <path d="M1 6l4 4 6-7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
    ),
    search: (
        <svg viewBox="0 0 12 12">
            <circle cx="5" cy="5" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.3" />
            <path d="M8 8l2 2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        </svg>
    ),
    email: (
        <svg viewBox="0 0 12 12">
            <rect x="1" y="2.5" width="10" height="7" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <path d="M1 4l5 3.5L11 4" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" fill="none" />
        </svg>
    ),
    phone: (
        <svg viewBox="0 0 12 12">
            <path d="M3 2h2l1 2.5-1.5 1c.5 1 1.5 2 2.5 2.5l1-1.5L10.5 7v2C9 10 4 8 2 4l1-2z" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
        </svg>
    ),
    folder: (color = '#F9AC60') => (
        <svg viewBox="0 0 14 14" fill="none">
            <rect x="1" y="3" width="12" height="9" rx="1.5" fill={color} opacity="0.3" stroke={color} strokeWidth="1.2" />
            <path d="M1 5h12" stroke={color} strokeWidth="1" opacity="0.6" />
            <path d="M1 3.5C1 2.7 1.7 2 2.5 2h3L7 3.5H1z" fill={color} opacity="0.5" />
        </svg>
    ),
    document: (color = '#50AEB3') => (
        <svg viewBox="0 0 14 14" fill="none">
            <rect x="2" y="1" width="9" height="12" rx="1.2" fill="none" stroke={color} strokeWidth="1.2" />
            <path d="M4 5h5M4 7h5M4 9h3" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.7" />
        </svg>
    ),
    chevron: (
        <svg viewBox="0 0 8 8">
            <path d="M2 2l4 2-4 2z" fill="currentColor" />
        </svg>
    ),
    addContact: (
        <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="5" cy="4" r="2.5" />
            <path d="M1 10.5c0-2 1.8-3.5 4-3.5s4 1.5 4 3.5" />
            <path d="M9.5 2v3M8 3.5h3" />
        </svg>
    ),
};

/**
 * Single action button with left-border accent.
 * @param {{ icon: React.ReactNode, iconClass: string, label: string, sub: string, accent?: string, full?: boolean, onClick: () => void, disabled?: boolean }} props
 */
export default function ActionButton({ icon, iconClass = 'teal', label, sub, accent, full = false, onClick, disabled = false }) {
    const style = accent ? { '--accent': accent } : {};

    return (
        <button
            className={`action-btn${full ? ' full' : ''}`}
            style={style}
            onClick={onClick}
            disabled={disabled}
            id={`action-${label.toLowerCase().replace(/\s+/g, '-')}`}
        >
            <div className={`action-icon ${iconClass}`}>
                {icon}
            </div>
            <div>
                <div className="btn-label">{label}</div>
                <div className="btn-sub">{sub}</div>
            </div>
        </button>
    );
}
